import React from 'react';
import CampoNumero from './CampoNumero';
import { simboloMoneda } from '../services/negocioActual';
import { normalizarEnvio, resumenEnvio, HORAS_APARTADO } from '../utils/tiendaEnvio';
import { METODOS_PAGO, normalizarPago } from '../utils/tiendaPago';

const caja = { marginBottom: '16px', padding: '16px', background: '#F0FDFA', border: '1px solid #CCFBF1', borderRadius: '14px' };
const label = { display: 'block', margin: '12px 0 6px', fontSize: '13px', fontWeight: 700, color: '#374151' };
const input = { width: '100%', padding: '11px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
const opcion = (activo) => ({
  display: 'flex', gap: '10px', alignItems: 'flex-start', padding: '12px', borderRadius: '12px', cursor: 'pointer', textAlign: 'left',
  fontFamily: 'inherit', width: '100%', background: 'white',
  border: `2px solid ${activo ? '#0D9488' : '#E5E7EB'}`,
});

// Envíos de la tienda en línea: precio fijo a todo el país (con envío gratis
// desde un monto, opcional) o "varía" (se coordina por WhatsApp), y si la
// clienta puede recoger en la tienda. La bolsa muestra el envío y el total.
export default function EnvioTiendaConfig({ envio, onCambiar, guardando, pago, onCambiarPago }) {
  const e = envio || {};
  const c = normalizarEnvio(e);
  const cambiar = (campo, valor) => onCambiar({ ...e, [campo]: valor });
  const metodos = normalizarPago(pago).metodos;
  const alternarMetodo = (v) => onCambiarPago && onCambiarPago({ metodos: metodos.includes(v) ? metodos.filter((x) => x !== v) : [...metodos, v] });
  const s = simboloMoneda();
  const dinero = (n) => `${s} ${Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <div style={caja}>
      <div style={{ fontWeight: 700, fontSize: '15px' }}>🚚 Envíos y pagos de tu tienda en línea</div>
      <p style={{ margin: '4px 0 12px', fontSize: '12px', color: '#6B7280' }}>Así tu clienta ve el costo del envío en su bolsa antes de mandarte el pedido.</p>

      <div style={{ display: 'grid', gap: '8px' }}>
        <button type="button" disabled={guardando} style={opcion(c.modo === 'fijo')} onClick={() => cambiar('modo', 'fijo')}>
          <span style={{ fontSize: '20px' }}>📦</span>
          <span><b style={{ fontSize: '14px' }}>Precio fijo a todo el país</b><br /><small style={{ color: '#6B7280' }}>Ej: L 90 a cualquier parte de Honduras. Se suma solo al total.</small></span>
        </button>
        <button type="button" disabled={guardando} style={opcion(c.modo === 'coordinar')} onClick={() => cambiar('modo', 'coordinar')}>
          <span style={{ fontSize: '20px' }}>💬</span>
          <span><b style={{ fontSize: '14px' }}>Varía según el lugar</b><br /><small style={{ color: '#6B7280' }}>Tú le dices el costo por WhatsApp al contactarla.</small></span>
        </button>
      </div>

      {c.modo === 'fijo' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '0 12px' }}>
          <div>
            <label style={label}>Costo del envío</label>
            <CampoNumero valor={e.costo === undefined || e.costo === null ? '' : String(e.costo)} onChange={(v) => cambiar('costo', v)}
              prefijo={s} min={0} max={100000} deshabilitado={guardando} estilo={input} />
          </div>
          <div>
            <label style={label}>Envío gratis desde (opcional)</label>
            <CampoNumero valor={e.gratisDesde ? String(e.gratisDesde) : ''} onChange={(v) => cambiar('gratisDesde', v)}
              prefijo={s} min={0} max={100000} deshabilitado={guardando} estilo={input} />
          </div>
        </div>
      )}

      <label style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '14px', fontSize: '14px', cursor: 'pointer' }}>
        <input type="checkbox" checked={c.recoger} disabled={guardando} onChange={(ev) => cambiar('recoger', ev.target.checked)}
          style={{ width: '18px', height: '18px', accentColor: '#0D9488' }} />
        🏬 Mis clientas pueden recoger en la tienda (sin costo)
      </label>

      <p style={{ margin: '12px 0 0', padding: '10px 12px', borderRadius: '10px', background: 'white', fontSize: '13px', color: '#0F766E' }}>
        Tu clienta verá: <b>{resumenEnvio(c, dinero)}</b>
      </p>

      <label style={{ ...label, marginTop: '18px' }} htmlFor="apartar-horas">⏳ Apartar las piezas de cada pedido</label>
      <select id="apartar-horas" value={c.apartarHoras} disabled={guardando} onChange={(ev) => cambiar('apartarHoras', Number(ev.target.value))}
        style={{ ...input, backgroundColor: 'white' }}>
        {HORAS_APARTADO.map((h) => <option key={h} value={h}>{h === 0 ? 'No apartar' : `Por ${h} horas`}</option>)}
      </select>
      <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
        Mientras confirmas el pedido, esas piezas salen como "Apartado" en tu catálogo y otra clienta no las puede pedir. Se liberan solas al vencer, al registrar la venta o si cancelas el pedido.
      </p>

      {onCambiarPago && (
        <>
          <label style={{ ...label, marginTop: '18px' }}>💳 Formas de pago que aceptas</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '6px' }}>
            {METODOS_PAGO.map((m) => (
              <label key={m.valor} style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '10px 12px', borderRadius: '10px', background: 'white', border: `1.5px solid ${metodos.includes(m.valor) ? '#0D9488' : '#E5E7EB'}`, cursor: 'pointer', fontSize: '14px' }}>
                <input type="checkbox" checked={metodos.includes(m.valor)} disabled={guardando} onChange={() => alternarMetodo(m.valor)}
                  style={{ width: '17px', height: '17px', accentColor: '#0D9488' }} />
                {m.icono} {m.nombre}
              </label>
            ))}
          </div>
          <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#9CA3AF' }}>Tu clienta elige una al hacer su pedido. El cobro lo coordinas tú por WhatsApp (los datos de tu cuenta no se publican).
            {metodos.includes('link') && <> Con <b>Link de pago</b>, generas el link en tu banco o pasarela (por ejemplo, el link de pago de tu POS) y se lo mandas a tu clienta.</>}</p>
        </>
      )}
    </div>
  );
}
